module.exports = __webpack_public_path__ + "img/u77.fa1121ad.png";